import { z } from 'zod';

export enum InitialState {
  active = 'ACTIVE',
  passive = 'PASSIVE',
}

export const InitialStateSchema = z.nativeEnum(InitialState).nullable();
